export type PaymentStatus = "succeeded" | "pending" | "failed" | "refunded";
export type PaymentType = "deposit" | "balance" | "full" | "refund";

export type Payment = {
  id: string;
  projectId: string;
  customer: string;
  initials: string;
  color: string;
  amount: number;
  type: PaymentType;
  method: string;
  methodIcon: string;
  last4: string;
  status: PaymentStatus;
  date: string;
  fee: number;
};

export const payments: Payment[] = [
  {
    id: "PMT-30412",
    projectId: "MV-2042",
    customer: "Jonathan Park",
    initials: "JP",
    color: "bg-indigo-500",
    amount: 976,
    type: "deposit",
    method: "Visa",
    methodIcon: "ri-visa-fill",
    last4: "4242",
    status: "succeeded",
    date: "Jun 01, 09:14 AM",
    fee: 28.5,
  },
  {
    id: "PMT-30411",
    projectId: "MV-2039",
    customer: "Joaquin Rivera",
    initials: "JR",
    color: "bg-emerald-500",
    amount: 1380,
    type: "balance",
    method: "Mastercard",
    methodIcon: "ri-mastercard-fill",
    last4: "8821",
    status: "succeeded",
    date: "May 31, 03:42 PM",
    fee: 40.3,
  },
  {
    id: "PMT-30410",
    projectId: "MV-2041",
    customer: "Margaret Sullivan",
    initials: "MS",
    color: "bg-brand-500",
    amount: 480,
    type: "deposit",
    method: "Apple Pay",
    methodIcon: "ri-apple-fill",
    last4: "0021",
    status: "succeeded",
    date: "May 14, 11:08 AM",
    fee: 14.1,
  },
  {
    id: "PMT-30409",
    projectId: "MV-2038",
    customer: "Anika Brennan",
    initials: "AB",
    color: "bg-violet-500",
    amount: 2240,
    type: "balance",
    method: "Visa",
    methodIcon: "ri-visa-fill",
    last4: "1144",
    status: "succeeded",
    date: "May 30, 04:55 PM",
    fee: 65.4,
  },
  {
    id: "PMT-30408",
    projectId: "MV-2050",
    customer: "Devon & Lily Hartwell",
    initials: "DH",
    color: "bg-orange-600",
    amount: 624,
    type: "deposit",
    method: "Visa",
    methodIcon: "ri-visa-fill",
    last4: "5566",
    status: "succeeded",
    date: "May 29, 02:11 PM",
    fee: 18.2,
  },
  {
    id: "PMT-30407",
    projectId: "BK-7822",
    customer: "Marcus Tribble",
    initials: "MT",
    color: "bg-emerald-500",
    amount: 128,
    type: "deposit",
    method: "Visa",
    methodIcon: "ri-visa-fill",
    last4: "9011",
    status: "pending",
    date: "Jun 01, 08:42 AM",
    fee: 3.8,
  },
  {
    id: "PMT-30406",
    projectId: "MV-2045",
    customer: "Eleanor Whitfield",
    initials: "EW",
    color: "bg-fuchsia-500",
    amount: 1248,
    type: "deposit",
    method: "Bank Transfer",
    methodIcon: "ri-bank-line",
    last4: "—",
    status: "pending",
    date: "May 30, 09:18 AM",
    fee: 0,
  },
  {
    id: "PMT-30405",
    projectId: "MV-2049",
    customer: "Rebecca Lin",
    initials: "RL",
    color: "bg-cyan-600",
    amount: 108,
    type: "deposit",
    method: "Mastercard",
    methodIcon: "ri-mastercard-fill",
    last4: "3344",
    status: "failed",
    date: "May 28, 06:35 PM",
    fee: 0,
  },
  {
    id: "PMT-30404",
    projectId: "MV-2037",
    customer: "Marcus Tribble",
    initials: "MT",
    color: "bg-lime-600",
    amount: 580,
    type: "refund",
    method: "Visa",
    methodIcon: "ri-visa-fill",
    last4: "9011",
    status: "refunded",
    date: "May 29, 10:22 AM",
    fee: -17,
  },
  {
    id: "PMT-30403",
    projectId: "MV-2046",
    customer: "Carla Mendez",
    initials: "CM",
    color: "bg-amber-600",
    amount: 248,
    type: "deposit",
    method: "Apple Pay",
    methodIcon: "ri-apple-fill",
    last4: "8800",
    status: "succeeded",
    date: "May 26, 02:01 PM",
    fee: 7.3,
  },
  {
    id: "PMT-30402",
    projectId: "MV-2048",
    customer: "Genesis Holdings LLC",
    initials: "GH",
    color: "bg-teal-600",
    amount: 1570,
    type: "deposit",
    method: "Bank Transfer",
    methodIcon: "ri-bank-line",
    last4: "—",
    status: "succeeded",
    date: "May 24, 10:48 AM",
    fee: 0,
  },
  {
    id: "PMT-30401",
    projectId: "MV-2044",
    customer: "Travis & Hannah Bell",
    initials: "TB",
    color: "bg-emerald-600",
    amount: 328,
    type: "deposit",
    method: "Mastercard",
    methodIcon: "ri-mastercard-fill",
    last4: "7755",
    status: "succeeded",
    date: "May 22, 05:09 PM",
    fee: 9.6,
  },
];

export const paymentStats = [
  {
    label: "Revenue This Month",
    value: "$148,250",
    sub: "+12.4% vs last month",
    icon: "ri-money-dollar-circle-line",
    color: "text-emerald-600 bg-emerald-50",
    trend: "up",
  },
  {
    label: "Outstanding",
    value: "$24,180",
    sub: "across 11 invoices",
    icon: "ri-alert-line",
    color: "text-amber-600 bg-amber-50",
    trend: "flat",
  },
  {
    label: "Processed Today",
    value: "$2,456",
    sub: "6 transactions",
    icon: "ri-pulse-line",
    color: "text-brand-600 bg-brand-50",
    trend: "up",
  },
  {
    label: "Refund Rate",
    value: "1.2%",
    sub: "industry avg 2.4%",
    icon: "ri-arrow-go-back-line",
    color: "text-indigo-600 bg-indigo-50",
    trend: "down",
  },
];

export const monthlyRevenue = [
  { month: "Jan", revenue: 98400, refunds: 1200 },
  { month: "Feb", revenue: 112800, refunds: 1800 },
  { month: "Mar", revenue: 124200, refunds: 980 },
  { month: "Apr", revenue: 138600, refunds: 2240 },
  { month: "May", revenue: 132000, refunds: 1480 },
  { month: "Jun", revenue: 148250, refunds: 580 },
];

export const paymentMethodBreakdown = [
  { label: "Visa / Mastercard", value: 64, color: "bg-ink-900", icon: "ri-bank-card-line" },
  { label: "Apple / Google Pay", value: 18, color: "bg-brand-500", icon: "ri-apple-fill" },
  { label: "Bank Transfer (ACH)", value: 14, color: "bg-emerald-500", icon: "ri-bank-line" },
  { label: "Cash / Check", value: 4, color: "bg-amber-500", icon: "ri-cash-line" },
];